export default {"src":"https://s.sylndr.com/c-1ab3f05/_next/static/media/LimitedTimeOffer.ba9b3fc0.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};